import { useState, useCallback } from 'react'
import { toast } from '@sales-center/components'
import { useSelector } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'

import {
  isAPIError,
  isAPIValidationError,
  validationErrorsToMap,
} from '@user/store/services/crud'
import { updateSalesFunnel } from '../api'
import { useAppDispatch } from '@user/store/hooks'
import { selectDenormalizedEditFunnel } from '../editSlice'

type State = {
  errors: Map<string, string[]>
  status: 'idle' | 'pending' | 'success' | 'fail'
}

export function useUpdateSalesFunnel() {
  const dispatch = useAppDispatch()

  const [state, setState] = useState<State>(() => ({
    status: 'idle',
    errors: new Map(),
  }))

  const funnel = useSelector(selectDenormalizedEditFunnel)

  const execute = useCallback(async () => {
    try {
      setState({
        status: 'pending',
        errors: new Map(),
      })

      const result = await dispatch(updateSalesFunnel(funnel))

      if (updateSalesFunnel.fulfilled.match(result)) {
        setState({
          status: 'success',
          errors: new Map(),
        })
      } else {
        unwrapResult(result)
      }
    } catch (error) {
      setState(() => {
        if (isAPIError(error)) {
          toast.error(error.Message)
        } else if (isAPIValidationError(error)) {
          return {
            status: 'fail',
            errors: validationErrorsToMap(error),
          }
        }

        return {
          status: 'fail',
          errors: new Map(),
        }
      })
    }
  }, [dispatch, funnel])

  return {
    ...state,
    execute,
  }
}
